import { render } from "./AlterarColigadaModal.vue?vue&type=template&id=daa95390"
import script from "./AlterarColigadaModal.vue?vue&type=script&lang=js"
export * from "./AlterarColigadaModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\senar-sgo\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__